import { __rest, __assign } from 'tslib';
import MuiDialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';

var Dialog = React.forwardRef(function Dialog(_a, ref) {
    var _b = _a.fullScreen, fullScreen = _b === void 0 ? 'sm' : _b, restProps = __rest(_a, ["fullScreen"]);
    var responsiveFullScreen = useMediaQuery(function (theme) {
        if (typeof fullScreen === 'string') {
            return theme.breakpoints.down(fullScreen);
        }
        if (fullScreen) {
            return 'all';
        }
        return 'not all';
    });
    return (React.createElement(MuiDialog, __assign({}, restProps, { fullScreen: responsiveFullScreen, ref: ref })));
});

export { Dialog as default };
